export var PlacementFeeType;
(function (PlacementFeeType) {
    PlacementFeeType[PlacementFeeType["Fixed"] = 0] = "Fixed";
    PlacementFeeType[PlacementFeeType["Percentage"] = 1] = "Percentage";
})(PlacementFeeType || (PlacementFeeType = {}));
